// One setting in a list of them: its name and a line on what it does at the
// left, its control (a switch, a button) at the right, a hairline under it.
// Rows stack into a column the width of a form.
export default function SettingRow({ title, description = null, className = "", children, ...attrs }) {
    return (
        <div className={`flex items-center justify-between gap-x-[24px] gap-y-[10px] border-b border-[color:var(--line-soft)] py-[16px] max-[519px]:flex-wrap ${className}`} {...attrs}>
            <div className="grid min-w-0 gap-[3px]">
                <h3 className="m-0 text-[14px] font-medium leading-[1.35] text-[color:var(--ink)]">{title}</h3>
                {description ? <div className="text-[13px] leading-[1.45] text-[color:var(--muted)] [overflow-wrap:anywhere]">{description}</div> : null}
            </div>
            {children ? <div className="flex shrink-0 items-center gap-[8px]">{children}</div> : null}
        </div>
    );
}
